import styles from "./route-source-section-modals.module.css";
import { Modal } from "BEDROCK/shared-components/modal";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { GPXUploadButton } from "PosterEditor/common-components/gpx-upload-button";
import { CTAButton } from "BEDROCK/shared-components/cta-button";

interface RouteSourceSectionModalAppleDeviceProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RouteSourceSectionModalAppleDevice = (
  props: RouteSourceSectionModalAppleDeviceProps
) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className={styles.container} style={{ width: "400px" }}>
        <div className={styles.titleBar}>
          <UIIcon iconName="IPHONE-ACTIVITY" size={28} variant="REGULAR" />
          <h1>Upload a workout from your iPhone</h1>
        </div>
        <div className={styles.content}>
          <p>
            You can upload a walk, run, hike, or other activity as a GPS route
            right to your project
          </p>
          <ol>
            <li>
              First, <a href="https://www.trailart.store/auth">sign up</a> to
              your TrailArt account
            </li>
            <li>Download our iOS helper app, and sign in</li>
            <li>
              Follow the instructions to upload a route in a handful of taps!
            </li>
            <li>
              Return to TrailArt.store and you'll see your route in the Route
              Line tool (you might need to refresh the page!)
            </li>
          </ol>
          <div className={styles.appStoreLinks}>
            <a
              className={styles.gifContainer}
              href="https://apps.apple.com/us/app/trailart/id6753645992"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.iphoneActivityGif}
                src="/ios-app/iPHONE-ROUTE-FROM-ACTIVITY.png"
                alt="GPX file from Strava"
              />
            </a>
            <a
              className={styles.qrCode}
              href="https://apps.apple.com/us/app/trailart/id6753645992"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/ios-app/appstore-qr-badge.png" alt="jamiekelly.io" />
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};
